(function () {
    const wordsArray = [
        "Ο σκύλος μου είναι φοβικός...",
        "Ο σκύλος μου είναι αντιδραστικός...",
        "Ο σκύλος μου είναι κουτάβι...",
        "Ο σκύλος μου είναι ξεροκέφαλος...",
        "Ο σκύλος μου είναι εκνευριστικός...",
        "Ο σκύλος μου γαυγίζει ακατάπαυστα...",
        "Ο σκύλος μου πηδάει πάνω μας...",
        "Ο σκύλος μου λερώνει μέσα στο σπίτι...",
        "Ο σκύλος μου δεν ακούει...",
        "Ο σκύλος μου δεν ηρεμεί με τίποτα...",
        "Ο σκύλος μου με τραβάει στην βόλτα..."
    ];

    // Wait for the DOM content to fully load
    document.addEventListener("DOMContentLoaded", function () {
        // Initialize the Typed.js instance
        var typed = new Typed('#typing', {
            strings: wordsArray,
            typeSpeed: 80,
            backSpeed: 30,
            backDelay: 1000,
            shuffle: true,
            loop: true
        });
    });

    // Typed.js can be found at https://github.com/mattboldt/typed.js
})();